/**
 * Helper di formattazione byte → stringa leggibile.
 * Promosso a `@easyflow/shared` dal Task #1922 per riuso FE+BE
 * (Infra Health card expand inline + CPU/RAM/disco real-time).
 *
 * Convenzione: base binaria (1024), 1 decimale per >=GB, intero altrimenti.
 */
export function formatBytesHuman(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || !Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const;
  let n = bytes;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  const decimals = i >= 3 ? 1 : 0;
  return `${n.toFixed(decimals)} ${units[i]}`;
}

/**
 * "5d 12h 30m" da secondi. Per uptime nodi/processo.
 */
export function formatUptimeHuman(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || !Number.isFinite(seconds) || seconds < 0) return '—';
  const s = Math.floor(seconds);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return `${s}s`;
}
